import { Button, Icon, useCopyToClipboard } from '@dittolive/anvil'
import { CheckIcon, CopyIcon } from '@phosphor-icons/react'
import React from 'react'

type Props = {
  value: string
}

export default function DataBridgeStringFieldCopyAction({ value }: Props) {
  const [doCopy, recentlyCopied, canCopy] = useCopyToClipboard(value)

  if (!canCopy) {
    return null
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      title={!value ? 'Nothing to copy' : 'Copy value'}
      onClick={doCopy}
      className="focus-visible:outline-focus-outline flex shrink-0 outline-none focus-visible:outline-2 disabled:cursor-not-allowed disabled:opacity-60"
      data-testid="copyButton"
      disabled={!value}
    >
      {recentlyCopied ? (
        <Icon
          className="text-green-500"
          svg={<CheckIcon />}
          data-testid="recentlyCopiedIcon"
        />
      ) : (
        <Icon
          className="text-foreground-subtle"
          svg={<CopyIcon />}
          data-testid="copyIcon"
        />
      )}
    </Button>
  )
}

export const defaultStringActionRenderer = (value?: unknown) =>
  typeof value === 'string' ? (
    <DataBridgeStringFieldCopyAction value={value} />
  ) : undefined
